import {ContainerModule} from "inversify";
import {di} from "@dp-instant/core";
import {MainActionHomeEvolution} from "../actions/MainActionHomeEvolution";
import {TypesFlow} from "@dp-instant/interfaces";
import {AssetsPreloadActionHomeEvolution} from "../actions/AssetsPreloadActionHomeEvolution";

export const GameModule = new ContainerModule(() => {
    di.bind(TypesFlow.assetsPreload).to(AssetsPreloadActionHomeEvolution);
    di.bind(TypesFlow.mainAction).to(MainActionHomeEvolution);
});
